import { render, staticRenderFns } from "./ReportDownload.vue?vue&type=template&id=66750bfd&scoped=true&lang=pug"
import script from "./ReportDownload.vue?vue&type=script&lang=js"
export * from "./ReportDownload.vue?vue&type=script&lang=js"
import style0 from "./ReportDownload.vue?vue&type=style&index=0&id=66750bfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66750bfd",
  null
  
)

export default component.exports